/* ============================================================
   HOUSE OF ZEWARAT — main.js
   Handles: transparent-to-solid header, mobile menu, reviews carousel
   ============================================================ */

(function () {
  'use strict';

  const header = document.getElementById('site-header');

  // ── Transparent / Solid header based on hero scroll ──────
  if (header) {
    // Detect specific dark hero sections that need a transparent header
    const heroEl = document.querySelector('.hero, .about-hero, .nitya-hero, .verve-hero, .shipping-hero, .faq-hero, .jc-hero, .cart-hero, .product-hero, .contact-hero, .wishlist-hero');

    if (!heroEl) {
      // No hero on this page → always solid
      header.classList.add('header--always-solid');
    } else {
      const updateHeader = () => {
        // Go solid as soon as the user scrolls past 50px
        const isSolid = window.scrollY > 50;
        header.classList.toggle('header--solid', isSolid);
      };

      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader(); // run once on load
    }
  }

  // ── Mobile hamburger ─────────────────────────────────────
  const hamburger  = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
    });
  }

  // ── Reviews carousel ────────────────────────────────────
  function initCarousels () {
    const carousels = document.querySelectorAll('.reviews-carousel');
    carousels.forEach(carousel => {
      // Avoid double-initialization
      if (carousel.dataset.carouselInitialized) return;
      carousel.dataset.carouselInitialized = 'true';

      const container = carousel.closest('.container') || carousel.parentElement;
      const prevBtn = container.querySelector('.carousel-btn--prev');
      const nextBtn = container.querySelector('.carousel-btn--next');
      const counterEl = container.querySelector('.reviews-counter');

      const cards = Array.from(carousel.querySelectorAll('.review-card'));
      if (cards.length === 0) return;

      let current = 0;
      let autoplayTimer = null;

      function getPerView () {
        return window.innerWidth < 900 ? 1 : 3;
      }

      function updateCounter () {
        if (!counterEl) return;
        const currentDisplay = counterEl.querySelector('.reviews-counter-current');
        const totalDisplay = counterEl.querySelector('.reviews-counter-total');
        if (currentDisplay && totalDisplay) {
          currentDisplay.textContent = current + 1;
          totalDisplay.textContent = cards.length;
        } else {
          counterEl.textContent = (current + 1) + '/' + cards.length;
        }
      }

      function showCards () {
        const perView = getPerView();

        if (perView === 1) {
          // Mobile view: show exactly 1 card at current index
          cards.forEach((card, i) => {
            if (i === current) {
              card.style.display = 'flex';
              card.style.order = '0';
              card.classList.remove('is-active');
              void card.offsetWidth; // Force reflow to re-trigger transition animation
              card.classList.add('is-active');
            } else {
              card.style.display = 'none';
              card.classList.remove('is-active');
            }
          });
          updateCounter();
        } else {
          // Desktop view: show up to 3 cards
          if (cards.length <= 3) {
            cards.forEach(card => {
              card.style.display = 'flex';
              card.style.order = '';
              card.classList.remove('is-active');
            });
          } else {
            cards.forEach((card, i) => {
              const offset = (i - current + cards.length) % cards.length;
              if (offset < 3) {
                card.style.display = 'flex';
                card.style.order = offset;
                card.classList.remove('is-active');
                void card.offsetWidth;
                card.classList.add('is-active');
              } else {
                card.style.display = 'none';
                card.classList.remove('is-active');
              }
            });
          }
        }

        // Show/hide navigation arrows based on card count
        const controls = container.querySelector('.carousel-controls');
        const totalNeeded = perView === 1 ? 1 : 3;
        const hasOverflow = cards.length > totalNeeded;

        if (controls) controls.style.display = hasOverflow ? 'flex' : 'none';
        if (prevBtn) prevBtn.style.display = hasOverflow ? 'flex' : 'none';
        if (nextBtn) nextBtn.style.display = hasOverflow ? 'flex' : 'none';
      }

      function prev () {
        if (current <= 0) {
          current = cards.length - 1;
        } else {
          current -= 1;
        }
        showCards();
        restartAutoplay();
      }

      function next () {
        if (current >= cards.length - 1) {
          current = 0;
        } else {
          current += 1;
        }
        showCards();
        restartAutoplay();
      }

      function startAutoplay () {
        stopAutoplay();
        const perView = getPerView();
        const minCards = perView === 1 ? 1 : 3;
        if (cards.length > minCards) {
          autoplayTimer = setInterval(() => {
            next();
          }, 3000);
        }
      }

      function stopAutoplay () {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function restartAutoplay () {
        stopAutoplay();
        startAutoplay();
      }

      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      // Pause autoplay on mouse hover (desktop)
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      // Mobile touch swipe support
      let touchStartX = 0;
      let touchEndX = 0;
      carousel.addEventListener('touchstart', e => {
        stopAutoplay();
        if (e.changedTouches && e.changedTouches.length > 0) {
          touchStartX = e.changedTouches[0].screenX;
        }
      }, { passive: true });

      carousel.addEventListener('touchend', e => {
        if (e.changedTouches && e.changedTouches.length > 0) {
          touchEndX = e.changedTouches[0].screenX;
          const diffX = touchEndX - touchStartX;
          if (Math.abs(diffX) > 40) {
            if (diffX < 0) {
              next();
            } else {
              prev();
            }
          }
        }
        restartAutoplay();
      }, { passive: true });

      // Pause when browser tab is inactive
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      function onResize () {
        showCards();
        restartAutoplay();
      }

      window.addEventListener('resize', onResize, { passive: true });

      // Initial render & start autoplay timer
      showCards();
      startAutoplay();

      // Store cleanup on element in case of re-init
      carousel._cleanupCarousel = function () {
        stopAutoplay();
        window.removeEventListener('resize', onResize);
      };
    });
  }

  // Run once immediately
  initCarousels();

  // Listen for Shopify Section Load in Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    const carousel = event.target.querySelector('.reviews-carousel');
    if (carousel) {
      if (typeof carousel._cleanupCarousel === 'function') {
        carousel._cleanupCarousel();
      }
      delete carousel.dataset.carouselInitialized;
      initCarousels();
    }
  });



  // ── Nitya collection filter tabs ─────────────────────────
  const filterTabs = document.querySelectorAll('.nitya-filter-tab');
  const productCards = document.querySelectorAll('.nitya-product-card');

  function applyNityaFilter(filter) {
    productCards.forEach(card => {
      const category = card.dataset.category || '';
      card.classList.toggle('is-hidden', category !== filter);
    });
  }

  if (filterTabs.length && productCards.length) {
    // Apply the active tab's filter on page load
    const activeNityaTab = document.querySelector('.nitya-filter-tab--active');
    if (activeNityaTab) applyNityaFilter(activeNityaTab.dataset.filter);

    filterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.filter;
        filterTabs.forEach(t => {
          t.classList.remove('nitya-filter-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('nitya-filter-tab--active');
        tab.setAttribute('aria-selected', 'true');
        applyNityaFilter(filter);
      });
    });
  }

  // ── Verve collection filter tabs ─────────────────────────
  const verveFilterTabs = document.querySelectorAll('.verve-filter-tab');
  const verveProductCards = document.querySelectorAll('.verve-product-card');

  function applyVerveFilter(filter) {
    verveProductCards.forEach(card => {
      const category = card.dataset.category || '';
      card.classList.toggle('is-hidden', category !== filter);
    });
  }

  if (verveFilterTabs.length && verveProductCards.length) {
    // Apply the active tab's filter on page load
    const activeVerveTab = document.querySelector('.verve-filter-tab--active');
    if (activeVerveTab) applyVerveFilter(activeVerveTab.dataset.filter);

    verveFilterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.filter;
        verveFilterTabs.forEach(t => {
          t.classList.remove('verve-filter-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('verve-filter-tab--active');
        tab.setAttribute('aria-selected', 'true');
        applyVerveFilter(filter);
      });
    });
  }

  // ── Sorting Logic ────────────────────────────────────────
  function setupSorting(selectId, gridId, cardClass) {
    const select = document.getElementById(selectId);
    const grid = document.getElementById(gridId);
    if (!select || !grid) return;

    const cards = Array.from(grid.querySelectorAll('.' + cardClass));
    
    // Store original DOM order for "newest" sorting
    cards.forEach((card, index) => {
      card.dataset.originalIndex = index;
    });

    select.addEventListener('change', () => {
      const sortBy = select.value;
      
      const sortedCards = Array.from(grid.querySelectorAll('.' + cardClass));

      sortedCards.sort((a, b) => {
        if (sortBy === 'newest') {
          return parseInt(a.dataset.originalIndex) - parseInt(b.dataset.originalIndex);
        }

        const getPrice = (card) => {
          const priceEl = card.querySelector('.price-current') || card.querySelector('[class$="-product-price"]');
          if (!priceEl) return 0;
          const priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
          return parseFloat(priceText) || 0;
        };

        const priceA = getPrice(a);
        const priceB = getPrice(b);

        if (sortBy === 'price-asc') {
          return priceA - priceB;
        } else if (sortBy === 'price-desc') {
          return priceB - priceA;
        }
        return 0;
      });

      // Re-append to grid in sorted order
      sortedCards.forEach(card => grid.appendChild(card));
    });
  }

  setupSorting('nitya-sort', 'nitya-product-grid', 'nitya-product-card');
  setupSorting('verve-sort', 'verve-product-grid', 'verve-product-card');

  // ── Product Page Gallery ─────────────────────────────────
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainImage = document.getElementById('MainProductImage');

  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        // Remove active class from all
        thumbnails.forEach(t => t.classList.remove('is-active'));
        // Add active to clicked
        this.classList.add('is-active');
        // Update main image src
        const newSrc = this.getAttribute('data-image-url');
        if (newSrc) {
          mainImage.src = newSrc;
        }
      });
    });
  }

  // ── Quantity Selectors (Product & Cart Page) ─────────────
  function updateQtyBtnStates(wrapper) {
    const qtyInput = wrapper.querySelector('.qty-input');
    const qtyMinus = wrapper.querySelector('.qty-minus');
    const qtyPlus = wrapper.querySelector('.qty-plus');
    if (!qtyInput) return;

    let currentVal = parseInt(qtyInput.value, 10) || 0;
    const minVal = qtyInput.hasAttribute('min') ? parseInt(qtyInput.getAttribute('min'), 10) : (window.location.pathname !== '/cart' ? 1 : 0);
    const maxAttr = qtyInput.getAttribute('max');
    const maxVal = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;

    if (qtyMinus) {
      if (currentVal <= minVal) {
        qtyMinus.style.opacity = '0.4';
        qtyMinus.style.pointerEvents = 'none';
      } else {
        qtyMinus.style.opacity = '1';
        qtyMinus.style.pointerEvents = 'auto';
      }
    }

    if (qtyPlus) {
      if (maxVal !== null && !isNaN(maxVal) && currentVal >= maxVal) {
        qtyPlus.style.opacity = '0.4';
        qtyPlus.style.pointerEvents = 'none';
      } else {
        qtyPlus.style.opacity = '1';
        qtyPlus.style.pointerEvents = 'auto';
      }
    }
  }

  function initQuantitySelectors() {
    const qtyWrappers = document.querySelectorAll('.product-quantity-wrapper, .cart-item-qty');

    qtyWrappers.forEach(wrapper => {
      updateQtyBtnStates(wrapper);
      if (wrapper.hasAttribute('data-qty-initialized')) return;
      wrapper.setAttribute('data-qty-initialized', 'true');

      const qtyMinus = wrapper.querySelector('.qty-minus');
      const qtyPlus = wrapper.querySelector('.qty-plus');
      const qtyInput = wrapper.querySelector('.qty-input');

      if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', (e) => {
          let currentVal = parseInt(qtyInput.value, 10) || 0;
          const minVal = qtyInput.hasAttribute('min') ? parseInt(qtyInput.getAttribute('min'), 10) : (window.location.pathname !== '/cart' ? 1 : 0);
          if (currentVal > minVal) {
            qtyInput.value = currentVal - 1;
            updateQtyBtnStates(wrapper);
            handleCartUpdate(qtyInput);
          } else {
            e.preventDefault();
          }
        });
        
        qtyPlus.addEventListener('click', (e) => {
          let currentVal = parseInt(qtyInput.value, 10) || 0;
          const maxAttr = qtyInput.getAttribute('max');
          const maxVal = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;
          
          if (maxVal !== null && !isNaN(maxVal) && currentVal >= maxVal) {
            e.preventDefault();
            updateQtyBtnStates(wrapper);
            return false;
          }
          
          qtyInput.value = currentVal + 1;
          updateQtyBtnStates(wrapper);
          handleCartUpdate(qtyInput);
        });

        qtyInput.addEventListener('change', () => {
          let currentVal = parseInt(qtyInput.value, 10) || 0;
          const minVal = qtyInput.hasAttribute('min') ? parseInt(qtyInput.getAttribute('min'), 10) : (window.location.pathname !== '/cart' ? 1 : 0);
          const maxAttr = qtyInput.getAttribute('max');
          const maxVal = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;
          
          if (currentVal < minVal) {
            qtyInput.value = minVal;
          } else if (maxVal !== null && !isNaN(maxVal) && currentVal > maxVal) {
            qtyInput.value = maxVal;
          }
          updateQtyBtnStates(wrapper);
          handleCartUpdate(qtyInput);
        });
      }
    });
  }

  function initUserAuthState() {
    function isUserLoggedIn() {
      // Mock login state
      if (localStorage.getItem('customer_mock_logged_in') === 'true') {
        return true;
      }
      // Real KwikPass check
      if (localStorage.getItem('kp_logged_in') === 'true') {
        return true;
      }
      const token = localStorage.getItem('kp_customer_token');
      if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
        return true;
      }
      // Check cookies
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('kp_customer_token=') || cookie.startsWith('kp_logged_in=')) {
          const val = cookie.split('=')[1];
          if (val && val !== 'undefined' && val !== 'null' && val !== 'false' && val.trim() !== '') {
            return true;
          }
        }
      }
      // Liquid check
      if (window.theme && window.theme.customerLoggedIn) {
        return true;
      }
      return false;
    }

    function updateUIState() {
      const loggedIn = isUserLoggedIn();
      const btnAccount = document.getElementById('btn-account');
      if (loggedIn) {
        document.body.classList.add('user-logged-in');
        if (btnAccount) btnAccount.setAttribute('aria-label', 'Account');
      } else {
        document.body.classList.remove('user-logged-in');
        if (btnAccount) btnAccount.setAttribute('aria-label', 'Account');
      }
    }

    updateUIState();
    
    // Periodically sync the UI state just in case Kwikpass status updates asynchronously
    setInterval(updateUIState, 1000);

    // When user is logged in, clicking the navbar account icon redirects to the account profile page
    document.addEventListener('click', (e) => {
      const btnAccount = e.target.closest('#btn-account');
      if (btnAccount && isUserLoggedIn()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const profileUrl = btnAccount.getAttribute('href') || '/account';
        window.location.href = profileUrl;
      }
    }, true);
  }

  let cartUpdateTimer = null;

  function handleCartUpdate(input) {
    const key = input.getAttribute('data-id');
    const qty = parseInt(input.value, 10);
    
    if (!key || isNaN(qty)) return;

    const cartItem = input.closest('.cart-item, .order-item');
    if (cartItem) {
      cartItem.style.opacity = '0.7';
    }

    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => {
      fetch('/cart/change.js?sections=main-cart,main-custom-checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(response => response.json())
      .then(data => {
        // Update navbar cart badge immediately
        const cartBtn = document.getElementById('btn-cart');
        if (cartBtn) {
          let badge = cartBtn.querySelector('.cart-count');
          if (data.item_count > 0) {
            if (badge) {
              badge.textContent = data.item_count;
            } else {
              badge = document.createElement('span');
              badge.className = 'cart-count';
              badge.textContent = data.item_count;
              cartBtn.appendChild(badge);
            }
          } else if (badge) {
            badge.remove();
          }
        }

        // Check if server capped the item quantity
        if (data && data.items && Array.isArray(data.items)) {
          const itemKey = input.getAttribute('data-id');
          const serverItem = data.items.find(i => i.key === itemKey || i.id == itemKey);
          if (serverItem) {
            if (serverItem.quantity !== parseInt(input.value, 10)) {
              input.value = serverItem.quantity;
              input.setAttribute('max', serverItem.quantity);
              const parentWrapper = input.closest('.product-quantity-wrapper, .cart-item-qty');
              if (parentWrapper) {
                updateQtyBtnStates(parentWrapper);
              }
            }
          }
        }

        // 1. If Section Rendering API returned section HTML directly
        let updatedSectionHTML = null;
        if (data.sections) {
          if (data.sections['main-cart']) {
            updatedSectionHTML = data.sections['main-cart'];
          } else if (data.sections['main-custom-checkout']) {
            updatedSectionHTML = data.sections['main-custom-checkout'];
          }
        }

        if (updatedSectionHTML) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(updatedSectionHTML, 'text/html');
          
          let newContent = doc.querySelector('.main-cart') || doc.querySelector('.checkout-right');
          let currentContent = document.querySelector('.main-cart') || document.querySelector('.checkout-right');
          
          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
            initQuantitySelectors();
            if (typeof window.initCheckoutDiscount === 'function') {
              window.initCheckoutDiscount();
            }
            return;
          }
        }

        // 2. Fallback fetch without forcing page reload
        fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            let newContent = doc.querySelector('.main-cart') || doc.querySelector('.checkout-right');
            let currentContent = document.querySelector('.main-cart') || document.querySelector('.checkout-right');
            
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
              initQuantitySelectors();
              if (typeof window.initCheckoutDiscount === 'function') {
                window.initCheckoutDiscount();
              }
            }
          })
          .catch(error => {
            console.error('Error updating cart view:', error);
            if (cartItem) cartItem.style.opacity = '1';
          });
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        if (cartItem) cartItem.style.opacity = '1';
      });
    }, 100);
  }

  // Run on initial load
  initQuantitySelectors();
  initUserAuthState();

  // ── Address Modal & LocalStorage Logic ───────────────────
  document.addEventListener('DOMContentLoaded', function() {
    const addressModal = document.getElementById('address-modal');
    const btnAddAddress = document.getElementById('btn-add-address');
    const modalClose = document.getElementById('address-modal-close');
    const addressForm = document.getElementById('address-form');
    const addressGrid = document.getElementById('checkout-address-grid');

    if (addressModal && addressGrid) {
      // Show modal
      const openModal = () => {
      addressModal.style.display = 'flex';
      setTimeout(() => addressModal.classList.add('is-open'), 10);
    };

    // Hide modal
    const closeModal = () => {
      addressModal.classList.remove('is-open');
      setTimeout(() => addressModal.style.display = 'none', 300);
    };

    if (btnAddAddress) btnAddAddress.addEventListener('click', openModal);
    if (modalClose) modalClose.addEventListener('click', closeModal);
    addressModal.addEventListener('click', (e) => {
      if (e.target === addressModal) closeModal();
    });

    // Render addresses from localStorage
    function renderAddresses() {
      const addressesStr = localStorage.getItem('checkout_addresses');
      let addresses = [];
      try {
        addresses = addressesStr ? JSON.parse(addressesStr) : [];
      } catch(e) {}

      // Keep the "Add Address" button
      const addBtnHtml = `
        <button class="address-card address-card--add" id="btn-add-address-dynamic">
          <span class="add-icon">+</span>
          <span>Add Address</span>
        </button>
      `;

      if (addresses.length === 0) {
        addressGrid.innerHTML = `
          <form class="address-form" id="inline-address-form" style="grid-column: 1 / -1; width: 100%; background: var(--cream, #F7F5F0); padding: 32px; border-radius: 8px; border: 1px solid rgba(107, 31, 42, 0.1);">
            <input type="email" id="inl_email" placeholder="Email *" required>
            <div class="form-row">
              <input type="text" id="inl_fname" placeholder="First Name *" pattern="[A-Za-z ]+" title="Only alphabets are allowed" required>
              <input type="text" id="inl_lname" placeholder="Last Name (Optional)" pattern="[A-Za-z ]*" title="Only alphabets are allowed">
            </div>
            <input type="tel" id="inl_mobile" placeholder="Phone Number *" pattern="[0-9]{10}" maxlength="10" minlength="10" title="Must be exactly 10 digits" required>
            <input type="text" id="inl_line1" placeholder="Address Line 1 *" required>
            <input type="text" id="inl_line2" placeholder="Address Line 2">
            <input type="text" id="inl_landmark" placeholder="Landmark (Optional)">
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; margin-bottom: 16px;">
              <input type="text" id="inl_pincode" placeholder="Pincode *" pattern="[0-9]{6}" maxlength="6" title="Must be exactly 6 digits" required>
              <input type="text" id="inl_city" placeholder="City *" required>
              <input type="text" id="inl_state" placeholder="State *" required>
            </div>
            
            <button type="submit" class="btn btn-primary btn-block place-order-btn-custom" style="margin-top: 16px;">Save Address</button>
          </form>
        `;

        const inlineForm = document.getElementById('inline-address-form');
        if (inlineForm) {
          inlineForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const newAddr = {
              email: document.getElementById('inl_email').value,
              fname: document.getElementById('inl_fname').value,
              lname: document.getElementById('inl_lname').value,
              mobile: document.getElementById('inl_mobile').value,
              line1: document.getElementById('inl_line1').value,
              line2: document.getElementById('inl_line2').value,
              landmark: document.getElementById('inl_landmark').value,
              city: document.getElementById('inl_city').value,
              state: document.getElementById('inl_state').value,
              pincode: document.getElementById('inl_pincode').value
            };
            addresses.push(newAddr);
            localStorage.setItem('checkout_addresses', JSON.stringify(addresses));
            renderAddresses(); 
          });
        }
      } else {
        // Build cards
        let html = '';
        addresses.forEach((addr, idx) => {
          const isChecked = idx === 0 ? 'checked' : '';
          const cardClass = idx === 0 ? 'address-card address-card--selected' : 'address-card';
          
          html += `
            <div class="${cardClass}" data-idx="${idx}">
              <div class="address-card-header">
                <label class="custom-radio">
                  <input type="radio" name="address" value="${idx}" ${isChecked}>
                  <span class="radio-mark"></span>
                  <span class="radio-label">Address ${idx + 1}</span>
                </label>
                <button type="button" class="btn-edit" data-idx="${idx}">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                  Edit
                </button>
              </div>
              <div class="address-card-body">
                <p>${addr.fname} ${addr.lname}</p>
                <p>${addr.line1}, ${addr.line2 ? addr.line2 + ',' : ''} ${addr.landmark ? addr.landmark + ',' : ''}</p>
                <p>${addr.city}, ${addr.state}, ${addr.pincode}</p>
                <p>${addr.mobile}</p>
              </div>
            </div>
          `;
        });
        
        addressGrid.innerHTML = html + addBtnHtml;

        // Add event listeners for new radio buttons
        const radios = addressGrid.querySelectorAll('input[name="address"]');
        radios.forEach(radio => {
          radio.addEventListener('change', (e) => {
            // Remove selected class from all
            addressGrid.querySelectorAll('.address-card:not(.address-card--add)').forEach(card => card.classList.remove('address-card--selected'));
            // Add to the checked one
            e.target.closest('.address-card').classList.add('address-card--selected');
          });
        });
      }

      // Re-bind Add Address button
      const newAddBtn = document.getElementById('btn-add-address-dynamic');
      if (newAddBtn) newAddBtn.addEventListener('click', openModal);
    }

    // Initial render
    renderAddresses();

    // Form submission
    if (addressForm) {
      addressForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const newAddr = {
          email: document.getElementById('addr_email').value,
          fname: document.getElementById('addr_fname').value,
          lname: document.getElementById('addr_lname').value,
          mobile: document.getElementById('addr_mobile').value,
          line1: document.getElementById('addr_line1').value,
          line2: document.getElementById('addr_line2').value,
          landmark: document.getElementById('addr_landmark').value,
          city: document.getElementById('addr_city').value,
          state: document.getElementById('addr_state').value,
          pincode: document.getElementById('addr_pincode').value
        };

        const addressesStr = localStorage.getItem('checkout_addresses');
        let addresses = [];
        try {
          addresses = addressesStr ? JSON.parse(addressesStr) : [];
        } catch(e) {}

        addresses.push(newAddr);
        localStorage.setItem('checkout_addresses', JSON.stringify(addresses));
        
        addressForm.reset();
        closeModal();
        renderAddresses();
      });
    }
  }
  });

  // ── Dropdown Search Bar & Predictive Search ──────
  const btnSearch = document.getElementById('btn-search');
  const searchBar = document.getElementById('search-bar');
  const searchInput = document.getElementById('Search-Input');

  if (btnSearch && searchBar && searchInput) {
    // Toggle search bar
    btnSearch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isActive = searchBar.classList.toggle('is-active');
      if (isActive) {
        setTimeout(() => {
          searchInput.focus();
        }, 100);
      }
    });

    // Prevent closing when clicking inside the search bar
    searchBar.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Close when clicking anywhere outside
    document.addEventListener('click', () => {
      searchBar.classList.remove('is-active');
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchBar.classList.remove('is-active');
      }
    });

    // Predictive search API query
    const resultsWrapper = document.getElementById('predictive-search-results');
    const loadingEl = resultsWrapper.querySelector('.predictive-search-loading');
    const gridEl = resultsWrapper.querySelector('.predictive-search-products-grid');
    const viewAllLink = resultsWrapper.querySelector('.predictive-search-view-all');
    let debounceTimer;

    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = searchInput.value.trim();

      if (query.length < 2) {
        resultsWrapper.style.display = 'none';
        gridEl.innerHTML = '';
        return;
      }

      // Show loading
      resultsWrapper.style.display = 'block';
      loadingEl.style.display = 'block';
      gridEl.innerHTML = '';
      viewAllLink.style.display = 'none';

      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
          .then(res => res.json())
          .then(data => {
            loadingEl.style.display = 'none';
            const products = data.resources?.results?.products || [];

            if (products.length === 0) {
              gridEl.innerHTML = '<div class="predictive-search-no-results">No products found</div>';
              return;
            }

            // Render products
            gridEl.innerHTML = products.map(product => {
              const image = product.image || product.featured_image || '';
              const price = product.price || '';
              return `
                <a href="${product.url}" class="predictive-search-item">
                  <img src="${image}" alt="${product.title}" class="predictive-search-item-image" />
                  <div class="predictive-search-item-info">
                    <h4 class="predictive-search-item-title">${product.title}</h4>
                    <span class="predictive-search-item-price">${price}</span>
                  </div>
                </a>
              `;
            }).join('');

            // View all link
            viewAllLink.setAttribute('href', `/search?q=${encodeURIComponent(query)}&type=product`);
            viewAllLink.style.display = 'inline-block';
          })
          .catch(err => {
            console.error('Predictive search error:', err);
            loadingEl.style.display = 'none';
            gridEl.innerHTML = '<div class="predictive-search-no-results">An error occurred while searching.</div>';
          });
      }, 300);
    });
  }

  // ── Pincode Auto-fill ──────
  document.addEventListener('input', async (e) => {
    if (e.target && (e.target.id === 'addr_pincode' || e.target.id === 'inl_pincode')) {
      const pincode = e.target.value;
      if (pincode.length === 6 && /^\d+$/.test(pincode)) {
        try {
          const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
          const data = await res.json();
          if (data && data[0] && data[0].Status === 'Success') {
            const postOffice = data[0].PostOffice[0];
            const city = postOffice.District;
            const state = postOffice.State;
            
            if (e.target.id === 'addr_pincode') {
              document.getElementById('addr_city').value = city;
              document.getElementById('addr_state').value = state;
            } else {
              document.getElementById('inl_city').value = city;
              document.getElementById('inl_state').value = state;
            }
          }
        } catch(err) {
          console.error('Error fetching pincode data', err);
        }
      }
    }
  });

  // ── Transform App Instagram Feed to Slider ────────────────
  function initAppInstaSlider() {
    const selectors = ['#instafeed', '.instafeed-container', '.elfsight-app-instagram-feed'];
    
    selectors.forEach(sel => {
      const container = document.querySelector(sel);
      if (!container) return;

      const runSetup = () => {
        if (container.dataset.sliderInitialized === 'true') return;
        
        // Find all image links or images inside
        const items = Array.from(container.querySelectorAll('a, img'));
        // Find the direct parent of these items which is grid or container
        if (items.length > 2) {
          setupAppSlider(container, items);
        }
      };

      // Watch for changes (asynchronous load)
      const observer = new MutationObserver(() => {
        // If the track is already in the container, don't run setup
        if (container.querySelector('.app-insta-track')) return;
        runSetup();
      });

      observer.observe(container, { childList: true, subtree: true });

      // Run once immediately in case it's already loaded
      runSetup();
    });
  }

  function setupAppSlider(container, items) {
    container.dataset.sliderInitialized = 'true';

    // Create track
    const track = document.createElement('div');
    track.className = 'app-insta-track';

    // Find the wrapper containing the items
    const firstItem = items[0];
    const wrapper = firstItem.parentElement;
    
    // Get all child items of this wrapper
    const children = Array.from(wrapper.children);
    
    // Move children to track
    children.forEach(child => {
      child.classList.add('app-insta-slide');
      track.appendChild(child);
    });

    // Add track to wrapper
    wrapper.appendChild(track);

    // Create nav controls
    const prevBtn = document.createElement('button');
    prevBtn.className = 'app-insta-nav prev';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.type = 'button';
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'app-insta-nav next';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.type = 'button';
    
    container.appendChild(prevBtn);
    container.appendChild(nextBtn);

    let currentIndex = 0;
    const gap = 16;

    function getPerView() {
      if (window.innerWidth <= 600) return 2;
      if (window.innerWidth <= 1024) return 3;
      return 5; // 5 items on desktop
    }

    function updateSlider() {
      const perView = getPerView();
      const maxIndex = Math.max(0, children.length - perView);
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      
      const slideWidth = children[0].getBoundingClientRect().width;
      const translateAmount = currentIndex * (slideWidth + gap);
      track.style.transform = `translateX(-${translateAmount}px)`;

      // Toggle controls display
      if (children.length <= perView) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
      }
    }

    function nextSlide() {
      const perView = getPerView();
      const maxIndex = Math.max(0, children.length - perView);
      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }
      updateSlider();
    }

    function prevSlide() {
      const perView = getPerView();
      const maxIndex = Math.max(0, children.length - perView);
      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex--;
      }
      updateSlider();
    }

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      nextSlide();
    });
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      prevSlide();
    });

    window.addEventListener('resize', updateSlider, { passive: true });
    updateSlider();

    // Auto-slide autoplay
    let interval = setInterval(nextSlide, 4000);
    container.addEventListener('mouseenter', () => clearInterval(interval));
    container.addEventListener('mouseleave', () => interval = setInterval(nextSlide, 4000));
  }

  // Run on load
  initAppInstaSlider();

  // Enforce digits-only and max 10 characters for phone inputs, and letters/spaces only for name inputs
  document.addEventListener('input', function (e) {
    if (!e.target) return;
    
    // Phone fields
    if (e.target.type === 'tel' || e.target.id === 'ContactForm-phone' || e.target.id === 'customer-phone') {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
      if (e.target.value.length > 10) {
        e.target.value = e.target.value.slice(0, 10);
      }
    }
    
    // Name fields
    if (e.target.tagName === 'INPUT' && (
      e.target.id.toLowerCase().includes('name') || 
      e.target.id.toLowerCase().includes('fname') || 
      e.target.id.toLowerCase().includes('lname')
    )) {
      e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    }
  });

})();
